import { IconFinancePercent12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectOffer } from 'shared/selectors';

import { trackTooltipOpen } from './tracking';
import { FloatingLabel } from '../../components/FloatingLabel';
import { useApplicationContext } from '../ApplicationContext';

type TSubsidisedMortgageLabelInfo = {
  text: string;
  tooltipTitle: string;
  tooltipText: string;
  tooltipLink: string;
};

const DEFAULT_SUBSIDISED_MORTGAGE_LABEL: TSubsidisedMortgageLabelInfo = {
  text: '',
  tooltipTitle: '',
  tooltipText: '',
  tooltipLink: '',
};

export function SubsidisedMortgageLabelContainer() {
  const { config } = useApplicationContext();
  const { isSubsidisedMortgage } = useSelector(selectOffer);

  const isAvailable = config.get<boolean>('frontend-offer-card.subsidizedMortgage.Enabled') && isSubsidisedMortgage;
  const { text, tooltipText, tooltipTitle } =
    config.get<TSubsidisedMortgageLabelInfo>('frontend-offer-card.subsidizedMortgageLabel') ||
    /* istanbul ignore next */ DEFAULT_SUBSIDISED_MORTGAGE_LABEL;

  const handleTooltipOpen = React.useCallback(() => trackTooltipOpen(), []);

  if (!isAvailable) {
    return null;
  }

  return (
    <FloatingLabel
      labelText={text}
      tooltipTitle={tooltipTitle}
      tooltipText={tooltipText}
      color="theme-dark"
      backgroundColor="brand-pink"
      icon={<IconFinancePercent12 color="current_color" />}
      onOpen={handleTooltipOpen}
    />
  );
}
